<template>
    <div class="w-100 h-100 position-relative host mobile" style="background-color: #fff;">
        <div class="pt-4"></div>
        <div class="page-body pb-4" >
            <div v-if="!ready"
                 style="display: flex;justify-content: center;align-items: center">
                <div style="font-size: 28px;color:white">
                    <div class="container">
                        {{error}}
                    </div>
                </div>
            </div>
            <div class="body-wrap" v-if="ready">
                <div class="login-table" style="padding: 10px 5px;width: 100%">
                    <img :src="previewImage" style="max-width: 100%" alt="邀请函">
                    <div v-if="single.message">
                        <div class="text-center font-weight-bolder text-danger"
                             v-html="single.message"></div>
                    </div>

                    <div v-if="url" class="px-3 text-center text-muted">
                        <div v-if="single.sso_message" class="mb-3 text-center">
                            {{single.sso_message}}
                        </div>
                        <el-button size="large" type="success" :loading="process.loading" round @click="jumpToHost">
                            <i class="el-icon-link"></i> 点击主持会议
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="position-absolute w-100 h-100 text-right"
             style="z-index:1;top:0;left:0;background-color: rgba(0,0,0,0.8)"
             v-if="wechat_notice_visible">
            <img src="../../assets/images/wechat-notice.png" style="max-width: 100%" alt="wechat-notice">
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import axios from "axios";

    export default {
        name: "host",
        components: {},
        data() {
            return {
                single: {},
                ready: false,
                error: '',
                url: null,
                wechat_notice_visible: false,
                previewImage:null,
            }
        },
        computed: {
            ...mapState(['user', 'process']),
            qrcode() {
                return !this.$organization.no_qrcode;
            }
        },
        methods: {
            ...mapMutations('user', ['setUserInfo']),
            jumpToHost() {
                if (this.$isWechat()) {
                    this.wechat_notice_visible = true;
                } else {
                    window.location.href = this.url;
                }
            },
            goInvitation() {
                axios.post(this.$apiUrl('User.Invitation'), {id: this.single.id,token:this.$route.query._t}, {
                    headers: {'user-token': this.$store.state.user.token},
                    responseType: "arraybuffer"
                }).then(res => {
                    return 'data:image/png;base64,' + btoa(
                        new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                }).then(data => {
                    this.previewImage = data //图片地址 <img src='data' />
                    this.invitation = true;
                });
            },

        },
        mounted() {
            if (!this.$route.query._t) {
                //this.$router.replace('/');
            } else {
                this.$api('Query.Host', {_t: this.$route.query._t}).then(res => {
                    if (res.data.success) {
                        this.single = res.data.data;
                        this.ready = true;

                        this.goInvitation();
                        if (this.single.start_url && !this.single.message) {
                            this.url = this.single.start_url;
                            const vm = this;
                            if (!this.$isWechat())
                                setTimeout(function () {
                                        window.location.href = vm.url;
                                    },
                                    30000);
                        }
                    } else {
                        this.error = res.data.text
                    }
                    console.log(res);
                });
            }
        }
    }
</script>

<style scoped lang="less">

    .host.mobile {

        .page-body {
            min-height: 493px;
            position: relative;
            text-align: center;

            .login-table {
                padding-top: 20px;
                padding-bottom: 20px;
                display: inline-block;
                text-align: left;

                color: white;
                list-style: none;

                li {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    display: flex;

                    label {
                        margin-right: 20px;
                        width: 80px;
                        text-align: right;
                        flex: 0 0 80px;
                    }

                    &>span {
                        flex: 1 1 400px;
                        font-weight: bold;
                        overflow: auto;
                    }

                    &>div {
                        flex: 1 1 400px;
                        font-weight: bold;
                        overflow: auto;
                    }
                }

                a {
                    color: azure;
                }
            }
        }

        .page-footer {
            min-height: 87px;
        }

        .page-container {
            position: relative;
            width: 100%;
            max-width: 990px;
            margin: 0 auto;

            .contact {
                position: relative;
                text-align: center;
                padding: 15px 0 20px 4px;
                line-height: 26px;
                font-size: 14px;

            }
        }
    }


</style>
